/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Winner_Nudge_SelfInputs */



/**
* | output |
* | --- |
* | "Congratulations on your win! Please upload your decklist so it's kept in the records." |
*
* @param {Decks_Winner_Nudge_SelfInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_winner_nudge_self = /** @type {((inputs?: Decks_Winner_Nudge_SelfInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Winner_Nudge_SelfInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bravo pour votre victoire ! Envoyez votre decklist pour qu'elle reste dans les archives.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Enhorabuena por la victoria! Suba su decklist para que quede en los archivos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Parabéns pela vitória! Envie sua decklist para que fique nos arquivos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Complimenti per la vittoria! Carichi la sua decklist perché resti negli archivi.")
	return /** @type {LocalizedString} */ ("Congratulations on your win! Please upload your decklist so it's kept in the records.")
});